import { jsx, jsxs } from "react/jsx-runtime";
import Skeleton__default from "antd/es/skeleton";
import classnames from "../../utils/classnames.js";
const DealerInfoScheduleSkeleton = ({ active, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule", className), children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__skeleton"), children: /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-schedule__column"), children: [
    /* @__PURE__ */ jsx(
      Skeleton__default,
      {
        active,
        title: false,
        paragraph: { rows: 1, width: "20%" },
        className: classnames("perxis-auto-dealer-info-schedule__skeleton-label")
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: [
      /* @__PURE__ */ jsx(
        Skeleton__default,
        {
          active,
          title: false,
          paragraph: { rows: 1, width: "50%" },
          className: classnames("perxis-auto-dealer-info-schedule__skeleton-value")
        }
      ),
      /* @__PURE__ */ jsx(
        Skeleton__default,
        {
          active,
          title: false,
          paragraph: { rows: 1, width: "50%" },
          className: classnames("perxis-auto-dealer-info-schedule__skeleton-value")
        }
      )
    ] })
  ] }) }) });
};
export {
  DealerInfoScheduleSkeleton as default
};
//# sourceMappingURL=DealerInfoScheduleSkeleton.js.map
